import React, { useState } from 'react';
import { Box, ClickAwayListener, IconButton, Tooltip, TooltipProps } from '@mui/material';
import { InfoOutlined, Search as SearchIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export interface SearchInfoButtonProps {
    tooltip?: React.ReactNode;
    onClick?: () => void;
    tooltipProps?: Partial<Omit<TooltipProps, 'title' | 'children'>>;
}

const SearchInfoButton = ({ tooltip, onClick, tooltipProps }: SearchInfoButtonProps) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    if (!tooltip && !onClick) {
        return <SearchIcon htmlColor="icon.default" />;
    }

    if (onClick) {
        return (
            <IconButton sx={{ padding: 0 }} onClick={onClick} aria-label={t('actions.searchInfo')}>
                <InfoOutlined htmlColor="icon.default" />
            </IconButton>
        );
    }

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Tooltip
                    describeChild
                    open={open}
                    onClose={() => setOpen(false)}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={tooltip}
                    placement="bottom-end"
                    PopperProps={{
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    fallbackPlacements: ['top', 'bottom', 'right', 'left'],
                                },
                            },
                            {
                                name: 'preventOverflow',
                                options: {
                                    rootBoundary: 'viewport',
                                },
                            },
                        ],
                    }}
                    {...tooltipProps}
                    arrow
                >
                <IconButton sx={{ padding: 0 }} onClick={() => setOpen(true)} aria-label={t('actions.searchInfo')}>
                        <InfoOutlined htmlColor="icon.default" />
                    </IconButton>
                </Tooltip>
        </ClickAwayListener>
    );
};

export default SearchInfoButton;
